
import React from 'react';
import { Box, ResponsiveContext } from 'grommet';
import { withTheme } from 'styled-components';

import PageHeader from './PageHeader';
import PageFooter from './PageFooter';

const getPadSize = (size) => {
    return {
        'large': '',
        'medium': '8px',
        'small' : '8px'
    }[size];
}

const Page = ({theme, children, ...props}) => {
    return (
        <ResponsiveContext.Consumer>
            {size => (
                <Box>
                    <PageHeader/>
                    <Box align="center" pad={getPadSize(size)}>
                        <Box style={{margin: 'auto', maxWidth: '1000px'}} {...props} fill >
                            {children}
                            <PageFooter/>
                        </Box>
                    </Box>
                </Box>
            )}
        </ResponsiveContext.Consumer>
    );
};

export default withTheme(Page);
